import axios from "axios";
import { BigsClub } from "../types/personnel";

const SERVICES_URL = process.env.SERVICES_URL;
const API_URL = `${SERVICES_URL}/club`;

export type ClubContactUpdate = {
    clubStatsId: number;
    contact: string;
    phone: string;
    email: string;
};

export type ClubOrgProfileUpdate = {
    clubStatsId: number;
    name?: string;
    state?: string | null;
    stateAbbrev?: string | null;
    city?: string | null;
};

export const getMajorClubs = (): Promise<BigsClub[]> =>
    axios.get(`${API_URL}/majors`).then(response => response.data);

export const getClubsByOrgStatsId = (orgStatsId: number): Promise<BigsClub[]> =>
    axios.get(`${API_URL}/org/${orgStatsId}`).then(response => response.data);

export const updateClubContact = (contact: ClubContactUpdate): Promise<BigsClub> =>
    axios.post(`${API_URL}/contact`, contact).then(response => response.data);

export const updateOrgProfileClubs = (updates: ClubOrgProfileUpdate[]): Promise<BigsClub[]> =>
    axios.post(`${API_URL}/org-profile`, updates).then(response => response.data);

export const getAllOrgsForOrgsPage = (): Promise<any> =>
    axios.get(`${API_URL}/viewRosterCertStatus`).then(response => response.data);

export const getOrgCertificationCount = (): Promise<any> =>
    axios.get(`${API_URL}/getOrgCertificationCount`).then(response => response.data);
